import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup, Button, Input, Label, Row, Col } from 'reactstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import ReactSelect from 'react-select';
import FormItem from '../../../common/forms/FormItem';
import RegisteredBusSelect from '../../../common/forms/select/RegisteredBusSelect';
import DatePicker from '../../../common/forms/input/DatePicker';
import { isRequired, validateEndDate } from '../../../../utils/validators';

const FORM_NAME = 'FuelDailyOperationalDashboardSearchForm';

const PERIOD_OPTIONS = [
  { value: 'today', label: 'Hoy' },
  { value: 'week', label: 'Últimos 7 días' },
  { value: 'month', label: 'Mes actual' },
  { value: 'previousMonth', label: 'Mes anterior' },
  { value: 'custom', label: 'Rango de fechas' },
];

const STATUS_OPTIONS = [
  { value: 'CALCULATED', label: 'Calculado' },
  { value: 'IN_PROGRESS', label: 'En curso' },
  { value: 'PENDING_LIQUIDATION', label: 'Pendiente liquidar' },
  { value: 'OVERDUE', label: 'Vencido' },
  { value: 'MISSING_REFILL', label: 'Retornado sin relleno' },
  { value: 'OBSERVED', label: 'Observado' },
];

const periodField = ({ input, ...rest }) => (
  <ReactSelect
    {...rest}
    isClearable={false}
    options={PERIOD_OPTIONS}
    value={PERIOD_OPTIONS.find((o) => o.value === input.value) || PERIOD_OPTIONS[0]}
    onChange={(opt) => input.onChange(opt ? opt.value : 'today')}
    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
    styles={{
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    }}
  />
);

const statusesField = ({ input, ...rest }) => (
  <ReactSelect
    {...rest}
    isMulti
    isClearable
    placeholder="Todos"
    options={STATUS_OPTIONS}
    value={STATUS_OPTIONS.filter((o) => (input.value || []).includes(o.value))}
    onChange={(opts) => input.onChange((opts || []).map((o) => o.value))}
    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
    styles={{
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    }}
  />
);

const circuitIdField = ({ input, ...rest }) => (
  <Input
    {...input}
    {...rest}
    type="number"
    min="1"
    placeholder="ID circuito (opcional)"
    onChange={(e) =>
      input.onChange(e.target.value === '' ? '' : Number(e.target.value))
    }
  />
);

const northChicoCheckbox = ({ input, id, label }) => (
  <FormGroup check className="mb-0">
    <Label check htmlFor={id}>
      <Input
        id={id}
        type="checkbox"
        checked={Boolean(input.value)}
        onChange={(e) => input.onChange(e.target.checked)}
        onBlur={input.onBlur}
      />{' '}
      {label}
    </Label>
  </FormGroup>
);

export class FuelDailyOperationalDashboardSearchForm extends Component {
  validateDate = (value, allValues) =>
    validateEndDate(value, allValues.fromDate);

  render() {
    const isCustomRange = this.props.period === 'custom';

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <FormGroup row>
          <FormItem label="Periodo">
            <Field name="period" component={periodField} />
          </FormItem>
        </FormGroup>
        {isCustomRange && (
          <FormGroup row>
            <FormItem label="Rango de fechas" required>
              <Row>
                <Col>
                  <Field
                    name="fromDate"
                    component={DatePicker}
                    placeholder="Fecha de inicio"
                    validate={[isRequired]}
                  />
                </Col>
                <Col>
                  <Field
                    name="toDate"
                    component={DatePicker}
                    placeholder="Fecha de fin"
                    validate={[isRequired, this.validateDate]}
                  />
                </Col>
              </Row>
            </FormItem>
          </FormGroup>
        )}
        <FormGroup row>
          <FormItem label="Bus (opcional)">
            <Field
              name="registeredBusId"
              component={RegisteredBusSelect}
              isMulti
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Circuito — ID (opcional)">
            <Field name="circuitId" component={circuitIdField} />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Estado (opcional)">
            <Field name="statuses" component={statusesField} />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Norte Chico">
            <Field
              name="includeNorthChicoRoutes"
              component={northChicoCheckbox}
              id="fuel-daily-ops-north-chico"
              label="Incluir rutas Norte Chico"
            />
          </FormItem>
        </FormGroup>
        <div className="FormButtonGroup">
          <Button type="submit" color="primary">
            Aplicar filtros
          </Button>
        </div>
      </Form>
    );
  }
}

FuelDailyOperationalDashboardSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  period: PropTypes.string,
};

FuelDailyOperationalDashboardSearchForm.defaultProps = {
  period: 'today',
};

const selector = formValueSelector(FORM_NAME);

const mapStateToProps = (state) => ({
  period: selector(state, 'period'),
});

export default connect(mapStateToProps)(
  reduxForm({
    form: FORM_NAME,
    initialValues: {
      period: 'today',
      statuses: [],
      includeNorthChicoRoutes: false,
    },
  })(FuelDailyOperationalDashboardSearchForm),
);
